module.exports = __webpack_public_path__ + "static/6-7aa46e33ddff3eaf9a24e995d5a9425b.jpg";